import { Component, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { FormControl, UntypedFormGroup } from '@angular/forms';
import { SlingConfig } from 'src/app/models';
import { SlingConfigService } from 'src/app/services/sling-config.service';
import { Marina } from 'src/app/models/marina';
import { StorageUtil } from 'src/app/utils/storage.util';
import { FinancialMultipleCompaniesType } from 'src/app/models/enums/finances/financial-multiple-companies-type';
import { Observable } from 'rxjs';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { ToastService } from 'src/app/services/toast.service';
import { CustomerService } from 'src/app/services/customer.service';

@Component({
  selector: 'app-billing-form',
  templateUrl: './billing-form.component.html',
  styleUrls: ['./billing-form.component.scss']
})
export class BillingFormComponent implements OnInit, OnChanges {
  @Input() formGroup: UntypedFormGroup;
  @Input() customer: any;
  
  billingCompanyOptions: any[] = [];
  slingConfig: SlingConfig;
  marina: Marina;
  showBillingCompanySection = false;
  isDialog = false;

  constructor(
    private slingConfigService: SlingConfigService,
    public dialogRef: DynamicDialogRef,
    public config: DynamicDialogConfig,
    private toastService: ToastService,
    private customerService: CustomerService
  ) {
    this.marina = StorageUtil.getMarina();

    
    if (this.config && this.config.data) {
      this.isDialog = true;
      this.customer = this.config.data.customer;

      
      if (!this.formGroup) {
        this.formGroup = new UntypedFormGroup({});
        this.formGroup.addControl('billingCompanyOptionId', new FormControl(null));
        this.formGroup.addControl('issRetidoFonte', new FormControl(this.customer?.issRetidoFonte || false));
      }
    }
  }

  ngOnInit(): void {
    
    this.loadConfigAndOptions();
  }

  private loadConfigAndOptions(): void {
    
    this.slingConfigService.getSlingConfigToday().subscribe({
      next: (config) => {
        
        this.slingConfig = config;
        this.createBillingCompanyOptions();
        
        if (!this.formGroup.get('billingCompanyOptionId')) {
          
          this.formGroup.addControl('billingCompanyOptionId', new FormControl(null));
        }
        
        if (!this.formGroup.get('issRetidoFonte')) {
          
          this.formGroup.addControl('issRetidoFonte', new FormControl(this.customer?.issRetidoFonte || false));
        }
        
        
        this.setInitialValue();
        this.showBillingCompanySection = this.enableFinancialCompanyOptions();
        

        
      },
      error: (error) => {
        
        this.toastService.error('Erro ao carregar configurações de faturamento');
      }
    });
  }

  private createBillingCompanyOptions(): void {
    
    let compArray: any[] = [];
    if (this.marina.marinaCompanies && this.marina.marinaCompanies.length > 0) {
      
      compArray = [
        {
          id: -1,
          companyFederalName: this.marina.companyName + ' (principal)',
          companyFederalId: this.marina.companyFederalId,
          invoiceGatewayId: null,
          expirationDigitalCertificate: null,
        },
        ...this.marina.marinaCompanies,
      ];
    }

    this.billingCompanyOptions = compArray.map((o) => ({
      label: o.companyFederalName + ' - ' + o.companyFederalId,
      value: o,
    }));
    
  }

  private setInitialValue(): void {
    
    if (!this.formGroup || !this.billingCompanyOptions || this.billingCompanyOptions.length === 0) {
      
      return;
    }

    
    
    let selectedOption = null;
    
    if (this.customer?.billingCompany) {
      
      
      if (this.customer.billingCompany.id !== undefined) {
        
        selectedOption = this.billingCompanyOptions.find(option => 
          option.value.id === this.customer.billingCompany.id);
        
        this.billingCompanyOptions.forEach((option, index) => {
          
        });
      } else if (this.customer.billingCompany === -1) {
        
        selectedOption = this.billingCompanyOptions.find(option => option.value.id === -1);
      }
    } else {
      
    }

    if (!selectedOption && this.billingCompanyOptions.length > 0) {
      
      selectedOption = this.billingCompanyOptions[0];
    }

    if (selectedOption) {
      
      this.formGroup.get('billingCompanyOptionId').setValue(selectedOption);
      
       
      
      if (!this.formGroup.get('billingCompanyOptionId').value) {
       
        this.formGroup.get('billingCompanyOptionId').setValue(selectedOption.value);
        
          
      }
    }

    if (this.customer?.issRetidoFonte !== undefined) {
      
      this.formGroup.get('issRetidoFonte').setValue(this.customer.issRetidoFonte);
    }
    
    
   
  }

  enableFinancialCompanyOptions(): boolean {
    const result = this.slingConfig?.financialMultipleCompaniesType === 
           FinancialMultipleCompaniesType.ByCustomer &&
           this.marina?.marinaCompanies?.length > 0;
    
    return result;
  }
  
  save(): void {
    
    if (!this.formGroup.valid) {
      this.toastService.warning('Por favor, preencha todos os campos obrigatórios');
      return;
    }

    const billingCompanyOption = this.formGroup.get('billingCompanyOptionId').value;
    
    const issRetidoFonte = this.formGroup.get('issRetidoFonte').value;
    
    const payload = {
      billingCompanyId: null,  // Inicializa como null por padrão
      issRetidoFonte: issRetidoFonte || false
    };
    
    if (billingCompanyOption) {
      
      
      if (billingCompanyOption.id !== undefined && billingCompanyOption.id !== null) {
        payload.billingCompanyId = billingCompanyOption.id === -1 ? null : billingCompanyOption.id;
        
      } 
      else if (billingCompanyOption.value && billingCompanyOption.value.id !== undefined) {
        payload.billingCompanyId = billingCompanyOption.value.id === -1 ? null : billingCompanyOption.value.id;
        
      }
    }
    
    
    
    if (this.customer) {
      this.customer.billingCompany = billingCompanyOption;
      this.customer.issRetidoFonte = issRetidoFonte;
    }
    
    this.toastService.success('Informações de faturamento salvas com sucesso');
    
    if (this.isDialog) {
      
      this.dialogRef.close(this.customer);
    }
    
    if (this.customer?.id) {
      
      this.customerService.saveBillingInfo(this.customer.id, payload).subscribe({
        error: (error) => {
          // Apenas loga o erro no console para fins de depuração
          
        }
      });
    } else {
      
    }
  }
  
  cancel(): void {

    if (this.isDialog) {
      this.dialogRef.close();
    }
  }
  
  ngOnChanges(changes: SimpleChanges): void {

    if (changes.customer && this.formGroup) {
      
      this.formGroup.get('issRetidoFonte')?.setValue(this.customer?.issRetidoFonte || false);
      
      if (this.customer?.billingCompany && this.billingCompanyOptions.length > 0) {
        
        this.setInitialValue();
      }
    }
  }
}